import "./../styles/ModelPage.scss";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { useState, useEffect } from "react";
import { ASSETS_PATH } from "../constants";
import { Button, IconButton } from "@mui/material";
import PopAddEditModelHotspot from "../components/Model/PopAddEditModelHotspot";

import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDeleteForever } from "react-icons/md";

// Three.js Scene
let canvasCreated = false;

let camera, scene, renderer;
let container;

let isUserInteracting = false;

let wWidth = 1200, wHeight = 700;

let raycaster = new THREE.Raycaster();
let hotspotCreation = false;
let helper;
let pointer = { x: 0, y: 0, z: 0 };
let frustum = new THREE.Frustum();
let cameraViewProjectionMatrix = new THREE.Matrix4();

let models;
let tHotspots = [];
let hotspotsGroup = new THREE.Group();;


const ModelPage = () => {

    const [hotspots, setHotspots] = useState([]);
    const [hotspot, setHotspot] = useState(null);
    const [hotspotIndex, setHotspotIndex] = useState(-1);
    const [sceneCreated, setSceneCreated] = useState(false);




    useEffect(() => {
        console.log('sceneCreated', sceneCreated)
        if (sceneCreated) {
            fetchModels();
            fetchHotspots();
        }else{
            init();
        }
    }, [sceneCreated]);


    useEffect(() => {
        console.log('hotspots', hotspots);
        reloadHotspots();
    }, [hotspots]);

    useEffect(() => {
        console.log('hotspot', hotspot);
    }, [hotspot]);

    const fetchHotspots = async () => {

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/model/read-mkey/model_hotspots`,
                { method: 'GET' });

            if (response.ok) {
                const h = await response.json();
                tHotspots = h;
                console.log(tHotspots);
                setHotspots(tHotspots);
            }
        } catch (e) {
            console.log(e);
        }
    }




    const onClickPlaceHotspot = () => {
        hotspotCreation = true;
    }


    const onCreateHotspot = (h) => {
        tHotspots = [...hotspots];
        tHotspots.push(h);
        console.log(tHotspots);
        setHotspots(tHotspots);
        onClosePop();
        //reloadHotspots();
    }

    const onClickEditHotspot = (h, i) => {
        setHotspot(h);
        setHotspotIndex(i);
    }

    const onClickDeleteHotspot = (h, i) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this hotspot?");
        if (!isConfirmed) return;
        tHotspots = [...hotspots];
        tHotspots.splice(i, 1);
        setHotspots(tHotspots);
        //reloadHotspots();
    }


    const onEditHotspot = (h) => {
        tHotspots = [...hotspots];
        tHotspots[hotspotIndex] = h;
        setHotspots(tHotspots);
        onClosePop();
        //reloadHotspots();
    }

    const onClosePop = () => {
        setHotspot(null);
        setHotspotIndex(-1);
    }


    const onSaveChanges = async () => {

        const body = JSON.stringify({ mkey: "model_hotspots", mvalue: JSON.stringify(hotspots) });

        try {
            await fetch(`${process.env.REACT_APP_API_URL}/model/update-mkey`, {
                method: 'PUT',
                body: body,
                headers: {
                    'Content-Type': 'application/json'
                },
            })
        } catch (e) {
            console.log(e);
        }
    }


    ///////////////////////////////////////////////////
    //////// STRT THREEJS /////////////////////////////
    ///////////////////////////////////////////////////

    const init = () => {

        container = document.getElementById('scene3d');
        scene = new THREE.Scene();

        camera = new THREE.PerspectiveCamera(75, wWidth / wHeight, 0.1, 1100);
        camera.position.set(0, 0, 2);
        //    scene.add(camera);

        hotspotsGroup = new THREE.Group();
        scene.add(hotspotsGroup);

        // helper geometry
        const geometryHelper = new THREE.ConeGeometry(0.1, 0.1, 3);
        geometryHelper.translate(0, 0, 0);
        geometryHelper.rotateX(Math.PI / 2);
        helper = new THREE.Mesh(geometryHelper, new THREE.MeshNormalMaterial());
        helper.visible = true;
        scene.add(helper);

        helper.position.set(pointer.x, pointer.y, pointer.z);

        renderer = new THREE.WebGLRenderer();
        renderer.setSize(wWidth, wHeight);
        renderer.setAnimationLoop(render);
        container.appendChild(renderer.domElement);

        const controls = new OrbitControls(camera, renderer.domElement);
        controls.addEventListener('change', render); // use if there is no animation loop
        controls.minDistance = 2;
        controls.maxDistance = 10;
        controls.target.set(0, 0, 0);
        controls.update();


        container.style.touchAction = 'none';
        //container.addEventListener('pointerdown', onPointerDown);

        window.addEventListener('resize', onWindowResize);


        setSceneCreated(true);

    }

    const fetchModels = async () => {

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/model`, { method: 'GET' })

            if (response.ok) {
                models = await response.json();
                loadModels();
            }
        } catch (e) {
            console.log(e);
        }
    }


    const loadModels = () => {

        models.forEach((m, i) => {
            const loader = new GLTFLoader();
            loader.load(`${ASSETS_PATH}/${m.model_file}`, function (gltf) {
                const model = gltf.scene.children[0].geometry;

                const texture = new THREE.TextureLoader().load(`${ASSETS_PATH}/${m.model_map}`, function (tx) {
                    tx.colorSpace = THREE.SRGBColorSpace;
                    const material = new THREE.MeshBasicMaterial({ map: texture });
                    const mesh = new THREE.Mesh(model, material);
                    scene.add(mesh);
                });


            });
        })

    }


    const onWindowResize = () => {

        camera.aspect = wWidth / wHeight;
        camera.updateProjectionMatrix();

        renderer.setSize(wWidth, wHeight);

        render();

    }


    const onPointerDown = (event) => {

        isUserInteracting = true;

        document.addEventListener('pointerup', onPointerUp);

        if (hotspotCreation) {
            onHotspotPlaced(event);
            hotspotCreation = false;
            return;
        }
    }


    const onPointerUp = (event) => {
        isUserInteracting = false;
        document.removeEventListener('pointerup', onPointerUp);
    }


    const onHotspotPlaced = (event) => {
        // hotspot creation start
        console.log("creting hostpost");

        const bound = container.getBoundingClientRect();
        pointer.x = ((event.clientX - bound.left) / renderer.domElement.clientWidth) * 2 - 1;
        pointer.y = - ((event.clientY - bound.top) / renderer.domElement.clientHeight) * 2 + 1;
        raycaster.setFromCamera(pointer, camera);

        // See if the ray from the camera into the world hits one of our meshes
        const intersects = raycaster.intersectObjects(scene.children);

        // Toggle rotation bool for meshes that we clicked
        if (intersects.length > 0) {
            const intersect = intersects[0];
            const normal = intersect.face.normal;
            const point = intersect.point;

            // Define the distance you want to offset the object
            const offsetDistance = 0.01; // Adjust this value as needed

            // Create a new Vector3 for the offset position
            const offsetPosition = new THREE.Vector3();
            offsetPosition.copy(point).add(normal.multiplyScalar(offsetDistance));

            helper.position.set(0, 0, 0); // Reset helper position if needed
            helper.lookAt(normal); // Make the helper look along the normal (optional, depending on your helper's purpose)
            helper.position.copy(offsetPosition); // Set the helper's position to the offset position

            pointer.x = helper.position.x;
            pointer.y = helper.position.y;
            pointer.z = helper.position.z;
            console.log({ coords: { ...pointer }, title: "", description: "", asset: "" });
            setHotspot(prev => { return { coords: { ...pointer }, title: "", description: "", asset: "" } });
            helper.position.set(0, 0, 0); // Reset helper position again
        }

        // hotspot creation end
    }



    const reloadHotspots = () => {
        let obj, i;

        for (i = hotspotsGroup.children.length - 1; i >= 0; i--) {
            obj = hotspotsGroup.children[i];
            hotspotsGroup.remove(obj);
            //console.log("hs removed")
        }

        let sp = new THREE.SphereGeometry(0.01, 12, 6);
        let planematerial = new THREE.MeshBasicMaterial({ color: 0x00ff00 });

        for (i = 0; i < tHotspots.length; i++) {

            let object = new THREE.Mesh(sp, planematerial);
            object.position.copy(tHotspots[i].coords);
            object.hotspot_id = i;
            object.visible = false;
            hotspotsGroup.add(object);
            //console.log("hs added", tHotspots[i].coords)
        }

        positionHotspots();
    }

    const positionHotspots = () => {
        let vector;
        let visible;

        for (let i = 0; i < hotspotsGroup.children.length; i++) {
            let obj = hotspotsGroup.children[i];

            vector = toScreenPosition(obj);
            visible = toScreenVisible(obj);

            //console.log(vector, visible);
            //console.log("poi-" + obj.hotspot_id);



            if (document.getElementById("hotspot-" + obj.hotspot_id)) {

                if (visible && vector.x > 0 && vector.x < wWidth && vector.y > 0 && vector.y < wHeight) {
                    document.getElementById("hotspot-" + obj.hotspot_id).style.display = "flex";
                    document.getElementById("hotspot-" + obj.hotspot_id).style.left = vector.x + "px";
                    document.getElementById("hotspot-" + obj.hotspot_id).style.top = vector.y + "px";
                } else {
                    document.getElementById("hotspot-" + obj.hotspot_id).style.left = 0 + "px";
                    document.getElementById("hotspot-" + obj.hotspot_id).style.top = 0 + "px";

                    document.getElementById("hotspot-" + obj.hotspot_id).style.display = "none";
                }

            }

        }
    }



    const toScreenPosition = (obj) => {


        var vector = new THREE.Vector3();
        obj.updateMatrixWorld();

        vector.setFromMatrixPosition(obj.matrixWorld);
        vector.project(camera);

        let width = wWidth;//renderer.getContext().canvas.width;
        let height = wHeight; //renderer.getContext().canvas.height;



        vector.x = Math.round((vector.x + 1) * width / 2);
        vector.y = Math.round(-(vector.y - 1) * height / 2);
        return {
            x: vector.x,
            y: vector.y
        };

    }

    /*     function toScreenVisible(obj) {
    
            camera.updateMatrixWorld();
    
            cameraViewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            frustum.setFromProjectionMatrix(cameraViewProjectionMatrix);
    
            var visible = frustum.intersectsObject(obj);
    
            return visible;
        } */
    const toScreenVisible = (obj) => {
        // 1. Frustum Culling (initial check - same as your original function)
        camera.updateMatrixWorld();
        //const cameraViewProjectionMatrix = new THREE.Matrix4();
        cameraViewProjectionMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        //const frustum = new THREE.MouthFrustum(); // Assuming you have THREE.MouthFrustum or similar
        frustum.setFromProjectionMatrix(cameraViewProjectionMatrix);

        let visible = frustum.intersectsObject(obj);

        if (!visible) {
            return false; // If not in frustum, definitely not visible
        }

        // 2. Occlusion Testing (Raycasting)
        // We'll cast a ray from the camera towards the object's center.
        // If something else intersects the ray *before* our object, then it's occluded.

        const raycaster = new THREE.Raycaster();
        const direction = new THREE.Vector3();
        const origin = new THREE.Vector3();

        // Get the object's world position
        const objWorldPosition = new THREE.Vector3();
        obj.getWorldPosition(objWorldPosition);

        // Set the ray origin to the camera's world position
        camera.getWorldPosition(origin);

        // Set the ray direction from the camera to the object
        direction.subVectors(objWorldPosition, origin).normalize();

        raycaster.set(origin, direction);

        // Find all intersections along the ray
        // You might want to filter what objects the raycaster considers.
        // For example, if you only want to check against specific layers or objects.
        const intersects = raycaster.intersectObjects(scene.children, true); // true for recursive check

        if (intersects.length > 0) {
            // Iterate through the intersections
            for (let i = 0; i < intersects.length; i++) {
                const intersection = intersects[i];

                // If the first intersected object is our 'obj', then it's visible.
                // Otherwise, something else is in front of it.
                if (intersection.object === obj) {
                    return true; // Our object is the first thing hit, so it's visible.
                } else if (intersection.distance < origin.distanceTo(objWorldPosition)) {
                    // If another object is hit *before* our 'obj', then 'obj' is occluded.
                    return false;
                }
            }
        }

        // If no intersections, or our object was the only one hit (meaning it wasn't occluded by anything else),
        // and it passed the frustum check, then it's visible.
        return true;
    }


    const render = () => {

        if (isUserInteracting) {
            positionHotspots();
        }

        renderer.render(scene, camera);
    }

    ///////////////////////////////////////////////////
    //////// END THREEJS /////////////////////////////
    ///////////////////////////////////////////////////



    return (
        <>
            <div className="flex flex-col gap-4">
                <div className="flex flex-row gap-4">

                    <div id="model-container">

                        <div id="scene3d" className="scene3d" onPointerDown={onPointerDown}>

                        </div>
                        <div id="hotspots-container" className="hotspots-container">
                            <div className="hotspots">
                                {hotspots.map((h, i) => {
                                    return (
                                        <div key={i} className="hotspot" id={`hotspot-${i}`}>
                                            <div className="hotspot-cover">
                                                <div className="hotspot-line"></div>
                                                <div className="hotspot-content  overflow-hidden whitespace-nowrap text-ellipsis">
                                                    {h.title}
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>

                        </div>

                    </div>
                    <div className="side-panel w-full flex flex-col gap-4">
                        <div>
                            Hotspots
                        </div>
                        <div className="flex flex-col gap-4">
                            {hotspots.map((h, i) => {
                                return (
                                    <div key={i} className="flex flex-row justify-between border p-4">
                                        <div className="w-[200px] overflow-hidden whitespace-nowrap text-ellipsis">{h.title}</div>
                                        <div>
                                            <IconButton onClick={() => onClickEditHotspot(h, i)}><FaRegEdit /></IconButton>
                                            <IconButton onClick={() => onClickDeleteHotspot(h, i)}><MdOutlineDeleteForever /></IconButton>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
                <div className="footer flex flex-row gap-4 justify-between">
                    <div>
                        <Button variant="contained" color="primary" onClick={onClickPlaceHotspot}>Place Hotspot</Button>
                    </div>
                    <div>
                        <Button variant="contained" color="primary" onClick={onSaveChanges}>Save Changes</Button>
                    </div>

                </div>
            </div>
            {hotspot && <PopAddEditModelHotspot hotspot={hotspot} onCreateHotspot={onCreateHotspot} onClosePop={onClosePop} hotspotIndex={hotspotIndex} onEditHotspot={onEditHotspot} />}
        </>
    )
}

export default ModelPage;



